import { render, staticRenderFns } from "./dashboard-widget.vue?vue&type=template&id=e0843f7c"
import script from "./dashboard-widget.vue?vue&type=script&lang=js"
export * from "./dashboard-widget.vue?vue&type=script&lang=js"
import style0 from "./dashboard-widget.vue?vue&type=style&index=0&id=e0843f7c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports